jQuery( document ).on( "page.ready", function () {
  $ = jQuery;

  if ( $( "main.single-products" ).length ) {
    var smcontroller = new ScrollMagic.Controller();

    if ( $( window ).width() < 950 ) {

      // Only make the ingredients a slider on Mobile
      var $ingredientsSlider = $( ".ingredients-slider .owl-carousel" );
      $ingredientsSlider.owlCarousel( {
        nav: false,
        items: 1,
        singleItem: true,
        rewind: true,
        rewindSpeed: 0,
        dots: true,
        lazyLoad: true,
        autoHeight: true
      } );

    } else {

      //Fancy scroll effect for can
      $( '.product-header' ).each( function () {
        var me = $( this ),
          pinItem = $( this ).children().children( '.desktop' ).children().children( '.label' ),
          pinHeight = $( me ).height(),
          height = ( ( pinHeight / 2 ) + ( ( document.documentElement.clientWidth / 100 ) * 2.5 ) );

        new ScrollMagic.Scene( {
            triggerElement: this,
            triggerHook: 0,
            duration: height,
            reverse: true,
          } )
          .setTween( pinItem[ 0 ], {
            y: "3.5%"
          } )
          .setPin( pinItem[ 0 ] )
          //.addIndicators()
          .addTo( smcontroller );
      } );

      $( '.product-header .container .desktop .container .bot' ).each( function () {
        var me = $( this ),
          item = $( this ).siblings( '.scrollmagic-pin-spacer' ).children( '.label' );

        var me = $( this );
        var flipTheSwitch = new ScrollMagic.Scene( {
            triggerElement: this,
            triggerHook: .3,
            reverse: true
          } )
          .setClassToggle( item[ 0 ], "i-just-flipped-the-switch" )
          .addTo( smcontroller );
      } );
      //End fancy scroll effect
    }

    /** Recommended Products Slider **/
    setTimeout( function () {
      if ( $( '.recommended-products .owl-carousel' ).length ) {
        var $productsSlider = $( '.recommended-products .owl-carousel' );
        $productsSlider.owlCarousel( {
          nav: true,
          rewind: true,
          rewindSpeed: 0,
          dots: false,
          loop: false,
          items: 1,
          navText: [
            '<svg xmlns="http://www.w3.org/2000/svg" width="103.324" height="51.143" viewBox="0 0 103.324 51.143"><g transform="translate(-6 -5.379)"><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M107.824 18H7.5" transform="translate(0 12.95)"/><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M30.95 54.4L7.5 30.95 30.95 7.5"/></g></svg>',
            '<svg xmlns="http://www.w3.org/2000/svg" width="103.324" height="51.143" viewBox="0 0 103.324 51.143"><g transform="rotate(180 50.912 24.51)"><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M100.324 0H0" transform="translate(0 23.45)"/><path style="fill: none;stroke: #231f20;stroke-linecap: round;stroke-linejoin: round;stroke-width: 3px" d="M23.45 46.9L0 23.45 23.45 0"/></g></svg>'
          ],
          responsive: {
            0: {
              items: 1,
            },
            768: {
              items: 2,
            },
            950: {
              items: 4,
            }
          }
        } )
      }
    }, 1500 );

    /** END Recommended Products Slider **/

  }
} );